import { render, staticRenderFns } from "./FileCard.vue?vue&type=template&id=72740cda"
import script from "./FileCard.vue?vue&type=script&lang=js"
export * from "./FileCard.vue?vue&type=script&lang=js"
import style0 from "./FileCard.vue?vue&type=style&index=0&id=72740cda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports